export default "/_next/static/images/c0078133c98cc65346e65f63022e8d04.jpg";